export default [
  {
    path: "/investments",
    name: "Investimentos",
    component: () =>
      import(
        /* webpackChunkName: "layout-investments" */ "./pages/investment/investment.component.vue"
      ),
  },
  {
    path: "/investments/:investment_id/edit",
    name: "Editar investimentos",
    component: () =>
      import(
        /* webpackChunkName: "investment_edit" */ "./pages/edit/edit.component.vue"
      ),
  },
];
